module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.2.1-rc.6-226.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/changelog/v2.2.1-rc.6.md
// module id = 667
// module chunks = 319